var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisitusLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 138,
    viewBox: "0 0 6 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 133L0.113249 138L5.88675 138L3.5 133L2.5 133ZM3.49999 5L5.88675 -1.26184e-07L0.113243 1.26184e-07L2.49999 5L3.49999 5ZM3.5 133.5L3.49999 4.5L2.49999 4.5L2.5 133.5L3.5 133.5Z",
    fill: "#094E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitusLine);
export default __webpack_public_path__ + "static/media/visitus-line.c0d7f50a0790e3684f599b2634a3eb81.svg";
export { ForwardRef as ReactComponent };